import request from "superagent";
import { last } from "lodash";
import { getTimesheetDistributionUrl } from "../utils/fileUpload";
import { GraphQlClient } from "../graphql/client";
import { GET_DISTRIBUTION_URL } from "../components/documentPreview/gql";
import { showErrorToast } from "@src/appV2/lib/Notifications";

export const downloadDocument = async (baseUrl: string, name: string) => {
  let response;
  if (!baseUrl) {
    return;
  }
  try {
    const url = baseUrl.replace(/^http:\/\//i, "https://");
    response = await request.get(url).responseType("blob");

    const file = response.body;
    const src = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = src;
    const urlArray = file.type.toLowerCase().split("/");
    const extension = last(urlArray);
    // oxlint-disable-next-line typescript/restrict-template-expressions
    link.setAttribute("download", `${name}.${extension}`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    showErrorToast(`Unable to load requested file ${name}`);
    throw error;
  }
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'fileStorageFileKey' implicitly has an 'any' type.
export const downloadTimesheet = async (fileStorageFileKey, shiftId, name) => {
  if (!fileStorageFileKey || !shiftId) {
    return;
  }
  const distributionUrl = await getTimesheetDistributionUrl(fileStorageFileKey, shiftId);

  void downloadDocument(distributionUrl, name);
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'docId' implicitly has an 'any' type.
export const downloadHcpDocument = async (docId, shiftId, name) => {
  if (!docId) {
    return;
  }
  try {
    const {
      data: { getDistributionUrl: { distributionUrl = "" } = {} },
    } = await GraphQlClient.query({
      query: GET_DISTRIBUTION_URL,
      variables: { docId, shiftId },
      fetchPolicy: "network-only",
    });

    void downloadDocument(distributionUrl, name);
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    showErrorToast(`Unable to fetch hcp document ${name}`);
  }
};
